'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _icons = require('../../icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * CloseButton component
 * @param {CloseButtonPropsType} props The field props
 * @returns {React.Element<*>} React element
 */
var CloseButton = function CloseButton(_ref) {
  var title = _ref.title,
      text = _ref.text,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'button',
    { onClick: onClick, tabIndex: '-1', className: 'qd__close-button', title: title },
    text ? _react2.default.createElement(
      'span',
      { className: 'qd__close-button-content' },
      text,
      '\xA0',
      _react2.default.createElement(_icons.ArrowRight, null)
    ) : _react2.default.createElement(_icons.X, null)
  );
};

exports.default = CloseButton;